<template>
  <div>
    <Overlay v-if="cargando" />
    <div class="evento">
      <div
        class="container-fluid"
        v-if="$route.params.ciudad === 'juarez'"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="evento.imagen"
            :alt="evento.nombre"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class="titulo-lugar-juarez">{{evento.nombre}}</h2>
        </div>
        <!-- <div class="row mb-2">
          <span>{{lugar.descripcion.type}}</span>
        </div> -->
        <div class="row mb-4">
          <div class="col-7">
            <span v-html="evento.descripcion"></span>
          </div>
          <div class="col-5">
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-juarez">Ubicación:</h3>
              </div>
              <div class="col">
                <span>{{evento.map.direccion}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-juarez">Fecha: </h3>
              </div>
              <div class="col">
                <span>{{evento.fecha[0]}}</span>
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class="titulo-lugar-juarez">Galeria</h2>
          </div>
          <div class="row gallery-juarez">
            <div class="col">
              <slick
                ref="slick"
                :options="slickOptions"
              >
                <img
                  v-for="(item,key) in evento.galeria"
                  :key="key"
                  @click="showModal(item)"
                  :src="item"
                  alt="evento.nombre"
                  class="gallery-slides"
                />
              </slick>
            </div>
          </div>
        </div>
      </div>
      <div
        class="container-fluid"
        v-if="$route.params.ciudad === 'el-paso'"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="evento.imagen"
            :alt="evento.nombre"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class="titulo-lugar-el-paso">{{evento.nombre}}</h2>
        </div>
        <!-- <div class="row mb-2">
          <span>{{}}</span>
        </div> -->
        <div class="row mb-4">
          <div class="col-7">
            <span v-html="evento.descripcion"></span>
          </div>
          <div class="col-5">
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-el-paso">Ubicación:</h3>
              </div>
              <div class="col">
                <span>{{evento.map.direccion}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-el-paso">Fecha: </h3>
              </div>
              <div class="col">
                <span>{{evento.fecha[0]}}</span>
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class="titulo-lugar-el-paso">Galeria</h2>
          </div>
          <div class="row gallery-el-paso">
            <div class="col">
              <slick
                ref="slick"
                :options="slickOptions"
              >
                <img
                  v-for="(item,key) in evento.galeria"
                  :key="key"
                  @click="showModal(item.url)"
                  :src="item"
                  alt="evento.nombre"
                  class="gallery-slides"
                />
              </slick>
            </div>
          </div>
        </div>
      </div>
      <div
        class="container-fluid"
        v-if="$route.params.ciudad === 'las-cruces'"
      >
        <div class="row justify-content-center pt-4 mb-2">
          <img
            :src="evento.media.url"
            :alt="evento.nombre"
            class="imagen-banner"
          >
        </div>
        <div class="row mt-2">
          <h2 class="titulo-lugar-las-cruces">{{evento.nombre}}</h2>
        </div>
        <!-- <div class="row mb-2">
          <span>{{}}</span>
        </div> -->
        <div class="row mb-4">
          <div class="col-7">
            <span v-html="evento.descripcion"></span>
          </div>
          <div class="col-5">
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-las-cruces">Ubicación:</h3>
              </div>
              <div class="col">
                <span>{{evento.map.direccion}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h3 class="titulo-lugar-las-cruces">Fecha: </h3>
              </div>
              <div class="col">
                <span>{{evento.fecha[0]}}</span>
              </div>
            </div>
          </div>
          <modal
            :foto="cover"
            @close-modal="modal=false"
            v-if="modal"
          />
          <div class="row mt-4">
            <h2 class="titulo-lugar-las-cruces">Galeria</h2>
          </div>
          <div class="row gallery-las-cruces">
            <div class="col">
              <slick
                ref="slick"
                :options="slickOptions"
              >
                <img
                  v-for="(item,key) in evento.galeria"
                  :key="key"
                  @click="showModal(item)"
                  :src="item.url"
                  alt="evento.nombre"
                  class="gallery-slides"
                />
              </slick>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import http from '@/helpers/http'
import Overlay from '@/helpers/Overlay'
import slick from 'vue-slick'
import '../../../node_modules/slick-carousel/slick/slick.css'
// import '../../../node_modules/slick-carousel/slick/slick-theme.css'
import modal from './modal.vue'
// import moment from 'moment'
export default {
  name: 'evento',
  props: [],
  components: {
    Overlay,
    slick,
    modal
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.reInit()
    })
  },
  data () {
    return {
      evento: {},
      cargando: true,
      modal: false,
      cover: null,
      slickOptions: {
        centerPadding: '60px',
        slidesToShow: 3
      }
    }
  },
  computed: {},
  mounted () {
    this.getEvento()
  },
  watch: {
    '$route.params': {
      deep: true,
      immediate: true,
      handler (value) {
        this.getEvento()
      }
    },
    evento: {
      immediate: true,
      deep: true,
      handler (value) {
        // console.log(value.fecha_evento.end) //error
        // value.fecha_evento.start = moment(value.fecha_evento.start).format('lll')
      }
    }
  },
  methods: {
    getEvento () {
      http.get('/eventos/' + this.$route.params.hash).then(res => {
        this.evento = res.data
        this.cargando = false
      }, err => {
        console.log(err)
      })
    },
    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    },
    showModal (foto) {
      this.cover = foto
      this.modal = true
    }
  }
}
</script>

<style lang="scss" scoped>
.evento {
  color: #5e5e5e;
  overflow: auto;
  height: 90vh;

  .imagen-banner {
    object-fit: cover;
    width: 100%;
    height: 25vh;
  }

  .titulo-lugar-juarez {
    color: #6f0f49;
    font-weight: bold;
  }

  .titulo-lugar-el-paso {
    color: #166073;
    font-weight: bold;
  }

  .titulo-lugar-las-cruces {
    color: #ee6225;
    font-weight: bold;
  }

  .texto-lugar {
    color: black;
    font-weight: bold;
    font-size: 1em;
  }

  .gallery-juarez {
    background-color: rgba($color: #6f0f49, $alpha: 0.7);
  }

  .gallery-el-paso {
    background-color: rgba($color: #166073, $alpha: 0.7);
  }

  .gallery-las-cruces {
    background-color: rgba($color: #ee6225, $alpha: 0.7);
  }

  .gallery-slides {
    object-fit: cover;
    height: 72px;
    width: 144px;
  }

  .bold {
    font-weight: bold;
  }
}
</style>
